import axios from 'axios';
import Echo from 'laravel-echo';
import Pusher, { type ChannelAuthorizationCallback } from 'pusher-js';
import type { ChannelAuthorizationData } from 'pusher-js/types/src/core/auth/options';
import Cookies from 'universal-cookie';

declare global {
   interface Window {
      Pusher: typeof Pusher;
   }
}

let echoInstance: Echo<'pusher'> | null = null;

const authorizeChannel = (
   channelName: string,
   socketId: string,
   callback: ChannelAuthorizationCallback,
) => {
   const jwtToken = new Cookies().get<string>('jwt');

   axios
      .post<ChannelAuthorizationData>(
         process.env.WEBSOCKET_AUTH_ROUTE ?? '',
         { socket_id: socketId, channel_name: channelName },
         {
            headers: {
               Authorization: `bearer ${jwtToken}`,
               Accept: 'application/json',
            },
         },
      )
      .then((response) => callback(null, response.data))
      .catch((error: Error) => callback(error, null));
};

export const getEcho = (): Echo<'pusher'> | null => {
   if (typeof window === 'undefined') return null;
   if (echoInstance) return echoInstance;

   window.Pusher = Pusher;

   echoInstance = new Echo({
      broadcaster: 'pusher',
      key: process.env.REVERB_APP_KEY,
      wsHost: process.env.REVERB_HOST,
      wsPort: Number(process.env.REVERB_PORT ?? 80),
      wssPort: 443,
      forceTLS: process.env.REVERB_SCHEME === 'https',
      cluster: '',
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      authorizer: (channel: { name: string }) => ({
         authorize: (
            socketId: string,
            callback: ChannelAuthorizationCallback,
         ) => authorizeChannel(channel.name, socketId, callback),
      }),
   });

   return echoInstance;
};
